import { useState } from 'react';
import { toast } from 'sonner';
import { FileText, Loader2, ShieldCheck } from 'lucide-react';
import { damagePdf } from '../lib/damagePdf';

const F = [['insurer', 'dmInsurer'], ['claim', 'dmClaim'], ['policy', 'dmPolicy'], ['holder', 'dmHolder'], ['place', 'dmPlace']];

// in-house: claim data for insurers + one-click damage report PDF
export default function DamageReport({ t, lang, project, updateProject }) {
  const dm = project.damage || {};
  const [busy, setBusy] = useState(false);
  const set = (p) => updateProject((pr) => ({ ...pr, damage: { ...(pr.damage || {}), ...p } }));
  const day = (k) => (dm[k] ? new Date(dm[k]).toISOString().slice(0, 10) : '');
  const go = async () => { setBusy(true); try { await damagePdf(project, lang); toast.success(t.dmSaved); } catch (e) { toast.error(String(e?.message || e)); } setBusy(false); };
  return (
    <div className="dm-box" data-testid="damage-report">
      <b><ShieldCheck size={16} /> {t.dmTitle}</b>
      <div className="dm-grid">
        {F.map(([k, l]) => <label key={k}>{t[l]}<input data-testid={`damage-${k}-input`} value={dm[k] || ''} placeholder={k === 'place' ? project.address || '' : ''} onChange={(e) => set({ [k]: e.target.value })} /></label>)}
        <label>{t.dmDate}<input type="date" data-testid="damage-date-input" value={day('date')} onChange={(e) => set({ date: e.target.value ? Date.parse(`${e.target.value}T12:00`) : null })} /></label>
        <label>{t.dmVisit}<input type="date" data-testid="damage-visit-input" value={day('visit')} onChange={(e) => set({ visit: e.target.value ? Date.parse(`${e.target.value}T12:00`) : null })} /></label>
      </div>
      <label>{t.dmCause}<textarea data-testid="damage-cause-input" placeholder={t.dmCausePh} value={dm.cause || ''} onChange={(e) => set({ cause: e.target.value })} /></label>
      <label>{t.dmMeasures}<textarea data-testid="damage-measures-input" placeholder={t.dmMeasuresPh} value={dm.measures || ''} onChange={(e) => set({ measures: e.target.value })} /></label>
      <small className="muted">{t.dmHint}</small>
      <button className="btn btn-red" data-testid="damage-pdf-btn" disabled={busy} onClick={go}>{busy ? <Loader2 size={16} className="spin" /> : <FileText size={16} />} {t.dmPdf}</button>
    </div>
  );
}
